import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=45cf3946&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"
import style0 from "./Menu.vue?vue&type=style&index=0&id=45cf3946&prod&lang=less"
import style1 from "./Menu.vue?vue&type=style&index=1&id=45cf3946&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cf3946",
  null
  
)

export default component.exports